import $ from './jquery.js';
import './append-around.js';
import './atd-map.js';
import './atd-modal.js';
import './atd-responsive-nav.js';
import './atd-slideshow.js';
import './atd-support.js';
import './atd-toggle-class.js';
import './atd-toggle-focus.js';
import './classList.js';
import './jquery.fancybox.min.js';
import validate from './validate.js';
import './vue-adv-search.js';


/* app code here */
$('.menu-item').each(function() {
	var link = $(this);
	
	if(!link.hasClass('current-menu-item') && !link.hasClass('current-menu-parent') && !link.hasClass('current-menu-ancestor')) {
		link.addClass('closed');
	}
});

$('.menu-item a').on('click', '.menu-after', function(e) {
	e.preventDefault();
	var link = $(this).closest('.menu-item'),
		menu = link.children('.sub-menu');
	// link.toggleClass('closed');
	// menu.slideToggle();
	if(menu.is(":visible")) {
		menu.slideUp({
			complete: function() {
				link.removeClass('open');
				link.addClass('closed');
			}
		});
	}
	else {
		menu.slideDown({
			complete: function() {
				link.removeClass('closed');
				link.addClass('open');
			}
		});
	}
});

if ($('[atd-slideshow]').length > 0) {
	$('[atd-slideshow]').slideshow({
		controls: {
			enabled: true,
			prevLabel: "",
			nextLabel: ""
		},
		autofit: true,
		swipe: true,
		autoplay: 10000
	});
}

$('[data-submit-on="change"]').on('change', function(e) {
	$(this).closest('form').submit();
});

$('#regionfinder').change(setCountryValue);

$('#rfq-form, #contact-form').on('submit', setCountryValue);

function setCountryValue() {
	var str = $('#regionfinder').val();
	var array = str.split(";",2);
	var cid = array[1];
	var rid = array[0];
	
	$('#country').val(cid);
	$('#00NC0000006d7ha').val(rid);
}

var partner_interest = {
	'construction' : 'Construction',
	'crushing' : 'CSAU',
	'dom-ex' : 'Dom-Ex',
	'engines' : 'ESUS',
	'mining' : {
		'global'        : 'MSUS',
		'canada'        : 'Canada',
		'chile'         : 'Chile',
		'australia'     : 'MSAU',
		'united-states' : 'MSUS',
		'peru'          : 'Peru'
	},
	'oil-gas' : 'MSTX'
};

if ( $('#js-region').length > 0 ) {
	var region = $('#js-region').val().toString();

	$('#00NC0000005Mu9C').change(function(e){
		var current_interest = $(this).find('option:selected').attr('data-slug');
		if (typeof partner_interest[current_interest] == 'object') {
			$('#00NC0000005N45T').val(partner_interest[current_interest][region]);
		} else {
			$('#00NC0000005N45T').val(partner_interest[current_interest]);
		}
	});
}
	

validate.init();
